module.exports = __webpack_public_path__ + "img/pro_nine_6.ae278668.jpg";